import { useState } from "react";

// Self-hosted flag images (public/assets/flags). Regional-indicator flag EMOJI do
// not render on Chrome/Windows, so we render a small <img> from the country's iso2.
// Graceful fallback: a neutral chip with the country code if iso2/file is missing.
export function Flag({ country, width = 20, className = "", rounded = "rounded-[2px]", testid }) {
  const iso2 = (country?.iso2 || "").toLowerCase();
  const name = country?.name || "";
  const code = (country?.sporty || country?.code || country?.iso3 || iso2 || "").toUpperCase();
  const [err, setErr] = useState(false);
  const height = Math.round(width * 0.75);

  if (!iso2 || err) {
    return (
      <span
        data-testid={testid}
        title={name || code}
        className={`inline-flex items-center justify-center font-mono font-bold text-slate-300 bg-[#222] border border-[rgba(212,175,55,0.25)] ${rounded} ${className}`}
        style={{ width, height, fontSize: Math.max(7, Math.round(height * 0.45)) }}
      >
        {code ? code.slice(0, 2) : "?"}
      </span>
    );
  }
  return (
    <img
      src={`/assets/flags/${iso2}.png`}
      srcSet={`/assets/flags/${iso2}@2x.png 2x`}
      width={width}
      height={height}
      alt={name}
      title={name}
      data-testid={testid}
      loading="lazy"
      onError={() => setErr(true)}
      className={`inline-block object-cover ${rounded} ${className}`}
      style={{ width, height }}
    />
  );
}
